import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PlusButton from '../../_common/elements/PlusButton';
import componentFunctions from '../../../../services/tools/componentFunctions';
import css from './InvoicesTable.module.css'; // Create or reuse this

function InvoicesTable({ data, showModal }) {
    const [filter, setFilter] = useState('');
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No invoice data available.</p>;
    }

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter invoices..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {sortedAndFilteredData.length}
                </div>
                <PlusButton onClick={showModal} />
            </div>

            <div>
                
            </div>

            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort('invoiceNo')} className={css.th}>
                            Invoice No
                        </th>
                        <th onClick={() => requestSort('invoiceDate')} className={css.th}>
                            Date
                        </th>
                        <th onClick={() => requestSort('customerName')} className={css.th}>
                            Customer
                        </th>
                        <th onClick={() => requestSort('contractTitle')} className={css.th}>
                            Contract
                        </th>
                        <th className={`${css.th} ${css.right}`}>Training</th>
                        <th className={`${css.th} ${css.right}`}>Access</th>
                        <th className={`${css.th} ${css.right}`}>Other</th>
                        <th className={`${css.th} ${css.right}`}>Total</th>
                        <th className={`${css.th} ${css.center}`}>Paid</th>
                        <th className={css.th}>Note</th>
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.map((item) => (
                        <tr
                            key={item.invoiceId}
                            className={css.row}
                            onClick={() => navigate(`/invoice/details/${item.invoiceId}`)}
                        >
                            <td>{item.invoiceNo}</td>
                            <td>{item.invoiceDate?.slice(0, 10)}</td>
                            <td>{item.customerName}</td>
                            <td>{item.contractTitle}</td>
                            <td className={css.right}>{Number(item.invoiceTrainingAmount).toFixed(2)}</td>
                            <td className={css.right}>{Number(item.invoiceAccessAmount).toFixed(2)}</td>
                            <td className={css.right}>{Number(item.invoiceOtherAmount).toFixed(2)}</td>
                            <td className={css.right}><strong>{Number(item.invoiceTotalAmount).toFixed(2)}</strong></td>
                            <td className={css.center}>
                                {item.isInvoicePaid === 1 ? '✔️' : '❌'}
                            </td>
                            <td>{item.invoiceNote}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

export default InvoicesTable;
